import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import BasicPage from '../components/layout/BasicPage.vue';
import HeaderPage from "../components/layout/HeaderPage.vue";
import LoginPage from '../components/layout/LoginPage.vue';
import OrderPage from '../components/order/OrderPage.vue';
import ProductList from '../components/product/ProductList.vue';
import Rental from '../components/Rental/RentalPage.vue';
import AccountPage from '../components/account/AccountPage.vue';
import ManageCompany from '../components/Manage/ManageCompany.vue';
import ManageClient from '../components/Manage/ManageClient.vue';
import ManageData from '../components/Manage/ManageData.vue';
import ManageSystem from '../components/Manage/ManageSystem.vue';
import ManageMigration from '../components/Manage/ManageMigration.vue';
import ClaimPage from '../components/claim/ClaimPage.vue';
import PaymentPage from '../components/payment/PaymentPage.vue';

// Electron 환경인지 확인
const isElectron = () => {
  // renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }
  // main process
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true;
  }
  // detect if run in electron by checking user agent
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }
  return false;
};

// 히스토리 모드 선택: Electron이면 Hash 모드, 그 외에는 History 모드
const history = isElectron() ? createWebHashHistory() : createWebHistory();

const router = createRouter({
  history: history,
  routes: [
    {
      path: '/',
      redirect: '/login', // 기본 경로를 로그인 페이지로 리디렉션
    },
    {
      path: '/login',
      component: BasicPage,
      children: [
        { path: "", name: "LoginPage", component: LoginPage, meta: { requiresAuth: false } }
      ]
    },
    {
      path: '/order',
      component: HeaderPage,
      children: [
        { path: "", name: "OrderPage", component: OrderPage, meta: { keepAlive: true } },
      ]
    },
    {
      path: '/productlist',
      component: HeaderPage,
      children: [
        { path: "", name: "ProductList", component: ProductList, meta: { keepAlive: true } }
      ]
    },
    {
      path: '/rental',
      component: HeaderPage,
      children: [
        { path: "", name: "Rental", component: Rental, meta: { keepAlive: true } }
      ]
    },
    {
      path: '/payment',
      component: HeaderPage,
      children: [
        { path: "", name: "PaymentPage", component: PaymentPage, meta: { keepAlive: true } }
      ]
    },
    {
      path: '/claim',
      component: HeaderPage,
      children: [
        { path: "", name: "ClaimPage", component: ClaimPage, meta: { keepAlive: true } }
      ]
    },
    {
      path: '/account',
      component: HeaderPage,
      children: [
        { path: "", name: "AccountPage", component: AccountPage, meta: { keepAlive: true } }
      ]
    },
    {
      path: '/manage',
      component: HeaderPage,
      children: [
        { path: "company", name: "ManageCompany", component: ManageCompany, meta: { keepAlive: true } },
        { path: "client", name: "ManageClient", component: ManageClient, meta: { keepAlive: true } },
        { path: "migration", name: "ManageMigration", component: ManageMigration, meta: { keepAlive: true } },
        { path: "data", name: "ManageData", component: ManageData, meta: { keepAlive: true } },
        { path: "system", name: "ManageSystem", component: ManageSystem, meta: { keepAlive: true } },
      ]
    },
  ],
});

export default router;